module.exports = __webpack_public_path__ + "assets/images/0338de565a7e6dabd184f3f2c56f4c4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/uro-times-2021.jpg
// module id = 412
// module chunks = 0